export default {
   "Search": "Suche",
   "Users": "Nutzer",
   "Email": "E-Mail",
   "Phone Number": "Telefonnummer",
   "Address": "Adresse",
   "Company login": "login",
  /***************** Sidebar *********/
    "Learning Center": "Learning Center",
 /****************** Navbar *************/
    "Logout": "abmelden",
    "Profile": "Profil",
    "Invoices":"Rechnungen",
 /****************** Dashboard Datatable ***********/
   "Title": "Name",
   "Version": "Version",
   "Module Slug": "Modul",
   "Progress": "Fortschritt",
   "Attempted on": "versucht am",
   "Score":"Punkte",
   "Your Quizes":"Quiz",
   "Launch":"Start",
   "Details":"Details",
   "Jump To Quiz": "Zum Test springen",
   "Rows per page": "Einträge per Seite",
 /****************** Users ***********/
    "Name": "Name",
    "Actions": "Aktionen",
    "Image" : "Bild",
    "Salutation": "Anrede",
    "Invite Users": "Nutzer einladen",
     "Date of birth": "Geburtsdatum",
     "All cards": "alle Karten",
     "Card added successfully":"Karte erfolgreich hinzugefügt",
     "Remove" :"entfernen",
     "User Profile": "Nutzer Profil",
     "All Cards": "Alle Kurse",
     "Add Card" : "Kurs hinzufügen",
     "Primary": "Primäre Farbe",
     "Are you sure want to remove?": "Wirklich entfernen?",
     "Subscribe" : "Teilnehmen",
     "Are you sure you want to purchase?":"Jetzt kaufen?",
     "Yes":"Ja",
     "No":"Nein",
     "You dont seem to have a card added to your profile":"Keine Zahlungsart hinterlegt",
     "Go to profile":"Kreditkarte hinterlegen",
 /****************** Courses ***********/
    "Filters":"Filter",
    "Know More": "zum Kurs",
    "Purchased": "gekauft",
    "Included" : "inkl.",
    "What Will you Learn?": "Was wirst du lernen?",
    "Requirements" : "Voraussetzungen",
    "Description" : "Beschreibung",
    "PLAY NOW": "jetzt starten",
    "Language": "Sprache",
   "Close": "Schließen",
   "Upload": "Hochladen",
   "Submit": "Absenden",
   "User csv file": "Nutzer CSV Datei",
   "Module name here": "Hier Kursnamen eintragen",
   "Subscription": "Abo",
   "Languages": "Sprachen",
   "Module": "Modul",
   "Subject": "Titel",
   "Body": "Nachricht",
   "Send copy to myself" : "Eine Kopie an mich senden",
   "Contact us": "Nimm Kontakt auf",
   "Status": "Status",
   "Join date": "Beitritt Datum",
   "Change status": "Status ändern",
   "Active": "aktiv",
   "Inactive":"inaktiv",
   "disable": "deaktivieren",
   "pending": "ausstehend",
   "Place of birth": "Geburtsort",
   "Subscribed":"Eingeschrieben",
   "Unsubscribed":"Nicht eingeschrieben",
   "English":"Englisch",
   "German":"Deutsch",
   "Write to Company Representative": "Einem Vertreter schreiben",
   "User updated successfully": "Nutzer erfolgreich aktualisiert",
   "User created successfully": "Nutzer erfolgreich erstellt",

   "Modules": "Module",
   "Your Modules": "Deine Module",
   "Documents": "Dokumente",
   'No modules found': "Keine Module gefunden",
   'Course':'Kurse',
   'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
   'Your attempted modules': 'Deine Modul Versuche',
   'No data found': 'keine Daten gefunden',
   'Search documents': 'Dokumente durchsuchen',
   'Time Spent' : 'Verbrachte Zeit',
   'From': 'vom',
   'To': 'bis zum',
   'Play':'abspielen',  
   'Your sessions': 'Deine Sessions',
   'Your attempts': 'Deine Versuche',    
   'Inbox': 'Inbox',
   'Settings': 'Einstellungen',
   'Update document' : 'Dokument erneuern',
   'View': 'ansehen',
   'User Documents':'Nutzer Dokumente',
   'Roles': 'Rollen',
   'Group': 'Gruppe',   
   'Comment (optional)': 'Kommentar (optional)',
   'Due date': 'gültig bis',
   'Select file': 'Dokument aussuchen',
   'Document name':'Name des Dokuments',
   'Days until': 'Tage gültig',
   'Template' : 'Vorlage',
   'Update': 'Update',
   'Edit': 'Editieren', 
   'Uploaded by': 'hochgeladen von',  
   'Uploaded on': 'hochgeladen am',
   'Type':'Typ',
   'Action':'Aktion',
   'Stage 1': 'Bereich 1',
   'Stage 2': 'Bereich 2',
   'Set Name': 'Name',
   'Show next': 'zeige die nächsten x Tage',
   'Show from':'zeige die darauffolgenden nächsten x Tage',   
   'Name is required': 'Name wird benötigt',
   'Invalid Email address': 'Keine gültige E-Mail Addresse',
   'Phone Number is required': 'Es wird eine Telefonnummer benötigt',
   'Salutation is required':'Ansprache wird benötigt',
   'Address is required': 'Adresse wird benötigt',
   'Group admin is required':'Gruppen Admin muss erstellt werden',
   'Groups are required': 'Gruppen werden benötigt',
   'Status is required': 'Status wird benötigt',
   'Date is required': '',
   'Mr': 'Herr',
   'Ms': 'Frau',
   'Mrs':'Frau',  
   'Document updated successfully':'Dokument erfolgreich ge-updated',
   'Create document':'Dokument erstellen',
   'Set Filter':'Filter setzen',
   'Location':'Ort',
   'Procedure': 'Prozedur',
   'Class':'Klasse',
   'Maker':'Hersteller',
   'Serial maker': '',
   'Stock':'Lager',
   'Good until date': 'gültig bis',
   'Equipment':'Ausstattung',
   'Number in stock': 'Lagerbestand',
   'Location is required':'Der Ort wird benötigt',
   'Class is required':'Klasse wird benötigt',
   'Maker is required':'Hersteller wird benötigt',
   'Number in stock is required':'Lagerbestand wird benötigt',
   'Goods until date is required':'Gültig bis wird benötigt',
   'Procedure is required':'Prozedur wird benötigt',
   'Description is required':'Beschreibung wird benötigt',
   'Equipment created successfully':'Equipment erfolgreich angelegt',
   'Equipment updated successfully':'Equipment erfolgreich ge-updated',
   'Group name': 'Gruppen-Name',
   'Group admins': 'Gruppen Administratoren',
   'Group name is required':'Gruppen-Name wird benötigt',
   'Users are required': 'Nutzer werden benötigt',
   'Course are required':'Kurse werden benötigt',
   'Documents are required':'Dokumentenvorlagen werden benötigt',
   'Company settings': 'Account Administration',
   'Company Color': 'Firmen Primärfarbe',
   'Session login time': 'Login Zeit',
   'Primary color is required':'Farbe kann nicht leer sein',
   'Company settings updated successfully':'Firmeneinstellungen erfolgreich geändert',
   'Intellectual Property Rights':'Rechte an geistigem Eigentum',
   'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Sofern nicht anders angegeben, sind die Website und alle Quellcodes, Datenbanken, Funktionen, Software, Website-Designs, Audio-, Video-, Text-, Foto- und sonstigen Lernmaterialien auf der Website (zusammen der „Inhalt“) sowie die Marken, Dienstleistungsmarken, und darin enthaltene Logos (zusammen die „Marken“)  durch Urheber- und Markenrechte sowie verschiedene durch andere Rechte an geistigem Eigentum und an den Gesetzen gegen unlauteren Wettbewerb in Deutschland, ausländischen Gerichtsbarkeiten und internationalen Konventionen geschützt.',
   'I accept this (required)': 'Ich akzeptiere das (erforderlich)',
   'Please subscribe to a course': '',
   'Your score': '',
   'Max Score' : '',
   'Time taken':'',
   'Pass Score':'',
   'No subscribed courses found':''   
};
